<template>
  <div class="background-01">

    <v-layout v-if="!finprueba" row wrap class="actividad-3-productos">

      <ui-title-cen title="Actividad"></ui-title-cen>
      <v-container grid-list-md>
        <v-layout row wrap justify-center mt-4>
          <v-flex xs12 sm2 hidden-xs-only>
            <image-app class="animated bounceIn dura_1" :imaSize="120" :imaSrc="'design/red-arrow'" imaAlt=""></image-app>
          </v-flex>
          <v-flex xs12 sm7 class="animated flipInX dura_1">
            <p>{{actividad.introduccion}}</p>
          </v-flex>
          <v-flex xs12 sm3 hidden-xs-only>
            <image-app class="animated bounceIn dura_1" :imaSize="169" :imaSrc="'design/banco8-1-2'" imaAlt=""></image-app>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 class="text-xs-center">
            <ui-simple-lsc vidTittle="" :youtubeEmbed="actividad.preguntas[pregNum].video"></ui-simple-lsc>
          </v-flex>
        </v-layout>
      </v-container>
      <v-layout row wrap justify-center mt-2 class="animated fadeInUp dura_2">
        <v-flex xs12 sm2 text-xs-center>
          <ui-circle-span tabindex="0" id="botonej" :botProp="[pregNum+1, 'circ-med', 'back-red']" :aria="'Item número'+ (pregNum+1)"></ui-circle-span>
        </v-flex>
        <v-flex xs12 sm6>
          <p>
            {{actividad.preguntas[pregNum].pregunta}}
          </p>
        </v-flex>
      </v-layout>

    </v-layout>

    <v-layout v-if="!finprueba" row wrap justify-center mt-1>
      <v-flex xs12 text-xs-center>
        <ul class="unstyled-list" aria-label="Opciones">
          <li v-for="(bot, index) in actividad.buttons" :key="index" class="list-actpreguntas">
            <ui-button-circle @click.native="selOpcion(index, bot)" :partOne="bot.name[0]" :partTwo="bot.name[1]" :partThree="bot.name[2]" :aria="bot.arialab" class="animated rotateIn" :class="'dura_'+(index+2)"></ui-button-circle>
            <div class="act-retro" v-if="bot.seleccionado">
              <image-app :imaSize="30" :imaSrc="bot.eval?'logos-icons/ok-bullet':'logos-icons/wrong-bullet'" imaAlt=""></image-app>
            </div>
          </li>
        </ul>
      </v-flex>
    </v-layout>

    <div tabindex="0" id="alerta-final">
      <ui-act-pantallafinal :titleAccess="actividad.despedida[0] + actividad.despedida[1] + actividad.despedida[2]" v-if="finprueba">
        <template slot="partOne">{{actividad.despedida[0]}}<br></template>
        <template slot="partTwo">{{actividad.despedida[1]}}</template>
        <template slot="partThree">{{actividad.despedida[2]}}</template>
      </ui-act-pantallafinal>
    </div>

    <v-dialog ref="modalej" v-model="dialogOne" width="600" height="800">
      <div>
        <v-card class="" v-if="alerta === 'bien'">
          <v-flex v-if="pregNum < (actividad.buttons.length-1)" text-xs-center>
            <h3>¡Muy bien!</h3>
            <ui-button class="mt-3" content="Siguiente pregunta" aria="Siguiente pregunta" @click.native="sigPregunta()">
            </ui-button>
          </v-flex>
          <v-flex v-if="pregNum >= (actividad.buttons.length-1)" text-xs-center>
            <h3>Prueba finalizada ¡Muy bien!</h3>
            <ui-button class="mt-3" content="Finalizar" aria="" @click.native="finalizar()">
            </ui-button>
          </v-flex>
        </v-card>
        <v-card class="" v-if="alerta === 'mal'">
          <v-flex text-xs-center>
            <h3>¡Respuesta equivocada!</h3>
            <ui-button class="mt-3" content="Inténtalo otra vez" aria="Inténtalo otra vez" @click.native="reintentar()">
            </ui-button>
          </v-flex>
        </v-card>
      </div>
    </v-dialog>

  </div>
</template>

<script>
export default {
  props: {
    actividad: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dialogOne: false,
      alerta: "",
      pregNum: 0,
      opcClick: 0,
      finprueba: false
    };
  },
  methods: {
    selOpcion(event, arr) {
      this.opcClick = event + 1;
      arr.seleccionado = true;
      if (arr.opcion === this.actividad.preguntas[this.pregNum].respuesta) {
        this.dialogOne = true;
        arr.eval = true;
        this.alerta = "bien";
      } else {
        this.dialogOne = true;
        this.alerta = "mal";
      }
    },
    sigPregunta() {
      this.dialogOne = false;
      this.opcClick = 0;
      this.pregNum++;
      this.actividad.buttons.map(elem => {
        elem.seleccionado = false;
        elem.eval = false;
      });
      document.getElementById("botonej").focus();
    },
    reintentar() {
      this.dialogOne = false;
      document.getElementById("botonej").focus();
    },
    finalizar() {
      this.finprueba = true;
      this.dialogOne = false;
      this.$store.commit("nextShow", true);
      document.getElementById("alerta-final").focus();
    }
  }
};
</script>

<style lang="scss" scoped>
.list-actpreguntas {
  display: inline-block;
  vertical-align: top;
  margin: auto 10px;
  position: relative;
}
.act-retro {
  position: absolute;
  top: 0;
  right: 0;
}
</style>




// WEBPACK FOOTER //
// act-preguntas-01.vue?edc2c5da